import styled from 'styled-components';

import { Typography } from '@interstate/components/Typography';
import { TrashIcon } from '@interstate/components/Icons';

import { BreakPoint } from '@makemydeal/dr-activities-common';

export const IncentiveTotalsContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-bottom: 5rem;
`;

export const IncentiveTotalsColumn = styled.div`
    display: flex;
    flex-direction: column;
    width: 200px;
    margin: 16px 0 16px 0;

    @media (min-width: ${BreakPoint.SMALL}) {
        margin: 16px 16px 16px 0;
    }

    svg {
        color: ${({ theme }) => theme.linkColor};
    }
`;

export const IncentiveTotalsRow = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const ManualRebatesCardContent = styled(Typography)`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
`;

export const ManualRebatesFormContainer = styled.div`
    [data-testid^='incentive-row-'] {
        border: 1px solid transparent;
        border-radius: 8px;
        transition: background-color 0.15s ease, border-color 0.15s ease;
        padding-top: 0.6rem !important;
        padding-bottom: 0.6rem !important;
    }

    [data-testid^='incentive-row-']:last-child {
        padding-bottom: 0.6rem !important;
    }

    [data-testid^='incentive-row-']:hover {
        background-color: #f7f9fc;
        border-color: #c7d4e2;
    }

    .ids-input-layout-message-spacer {
        display: none !important;
    }

    .MuiOutlinedInput-root {
        border-radius: 8px !important;
        background: #fff;
        transition: box-shadow 0.15s ease, border-color 0.15s ease;
    }

    .MuiOutlinedInput-notchedOutline {
        border-radius: 8px !important;
        border-color: #cfd6dd !important;
        transition: border-color 0.15s ease;
    }

    .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
        border-color: #9aa7b4 !important;
    }

    .MuiOutlinedInput-root.Mui-focused {
        box-shadow: 0 0 0 3px rgba(0, 52, 104, 0.12);
    }

    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
        border-color: #003468 !important;
        border-width: 1px !important;
    }

    .text-input-program {
        grid-area: program;

        @media (min-width: ${BreakPoint.SMALL}) {
            grid-area: unset;
        }
    }

    .text-input-name {
        grid-area: name;

        @media (min-width: ${BreakPoint.SMALL}) {
            grid-area: unset;
        }
    }

    .text-input-code {
        grid-area: code;

        @media (min-width: ${BreakPoint.SMALL}) {
            grid-area: unset;
        }
    }

    .text-input-amount {
        grid-area: amount;
        min-width: 75px;
        @media (min-width: ${BreakPoint.SMALL}) {
            grid-area: unset;
        }
    }

    hr {
        bg-color: #cacfd9;
        width: 100%;
    }

    @media (min-width: ${BreakPoint.SMALL}) {
        .text-input-amount input {
            text-align: right;
        }
    }

    /* override styles when on base deal screen */

    > div:last-child {
        padding-bottom: 0 !important;
    }
`;

export const ManualRebatesTypeDisplayContainer = styled.div`
    .type-display {
        color: #6d727a;
        &:after {
            color: #dd2b2b;
            content: '*';
            display: inline-block;
            margin-left: 0.25rem;
        }
    }

    .type-value {
        color: ${({ theme }) => theme.tokens.BaseColorBlack};
        margin-top: 0.5rem;
        margin-left: 0.25rem;
    }
`;

export const TypeInputOrDisplayContainer = styled.div`
    grid-area: type;

    @media (min-width: ${BreakPoint.SMALL}) {
        grid-area: unset;
    }
`;

export const AddIncentiveContainer = styled.div`
    margin: 16px 0 8px 0;
`;

export const RebatesEditWrapper = styled.div`
    position: relative;
`;

export const RebatesEditOverlay = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.6);
    z-index: 1;
`;

export const StyledTrashIcon = styled(TrashIcon)`
    &.active {
        color: ${({ theme }) => theme.tokens.BaseColorBlue700};
    }
`;
